export function requiredLocation() {
  const dialogs = document.querySelectorAll('.el-dialog__wrapper');
  let openDialog = null;
  // 遍历对话框，找到当前打开的（display不为none的）
  for (const dialog of dialogs) {
    if (window.getComputedStyle(dialog).display !== "none") {
      openDialog = dialog;
      break; // 找到第一个打开的对话框即可
    }
  }

  const firstErrorItem = openDialog
    ? openDialog.querySelector(".el-form-item.is-error") 
    : document.querySelector(".el-form-item.is-error");
  if (firstErrorItem) {
    firstErrorItem.scrollIntoView({ 
      behavior: "smooth", 
      block: "center",  // 避免过度滚动
    });
  }
}